//@flow
import {createSelector} from 'reselect'
import {useSelector} from "react-redux";

const selectMenu = createSelector(
	(state) => state.menu,
	(item) => item.get('menu')?.toJS()
)

const selectMenuItems = createSelector(
	(state) => state.menu,
	(item) => item.get('menuItems').toJS()
)

const selectOpenItem = createSelector(
	(state) => state.menu,
	(item) => item.get('openItem')
)

const selectSelectedID = createSelector(
	(state) => state.menu,
	(item) => item.get('selectedID')
)

const selectDrawerOpen = createSelector(
	(state) => state.menu,
	(item) => item.get('drawerOpen')
)

const selectSelectedItems = createSelector(
	(state) => state.menu,
	(item) => item.get('selectedItems')
)
const selectSelectedLevel = createSelector(
	(state) => state.menu,
	(item) => item.get('selectedLevel')
)

const useMenuData = () => {
	const menu = useSelector(selectMenu)
	const menuItems = useSelector(selectMenuItems)
	const openItem = useSelector(selectOpenItem)
	const selectedId = useSelector(selectSelectedID)
	const drawerOpen = useSelector(selectDrawerOpen)
	const selectedItems = useSelector(selectSelectedItems)
	const selectedLevel = useSelector(selectSelectedLevel)
	return {
		menu,
		menuItems,
		openItem,
		selectedId,
		drawerOpen,
		selectedItems,
		selectedLevel
	}
}

export default useMenuData